module.exports = __webpack_public_path__ + "img/why-championla.05b687a2.jpg";